import styled, { css } from "styled-components";
import { Form, Divider, Select, Icon, Button } from "antd";
import { UnderlineLink, LinkTo, ErrorMessage } from "../../../../../../CommonComponents/commonStyles";

const styles = css`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.primary};
`;

export const PillButton = styled(Button)`
  &&& {
    border-radius: 1rem;
    height: unset;
    padding: 6px 20px;
  }
`;

const fontCommonStyle = css`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary}; 
  }
`;

const cursorPointer = css`
  cursor: pointer;
`;

export const BasicInfo = styled.div`
  ${fontCommonStyle}
  line-height: 1.5;
  margin-top: ${props => props.marginTop};
  margin-bottom: ${props => props.marginBottom};
  font-weight: ${props => props.fontWeight};
  margin-left: ${props => props.marginLeft};
  margin-right: 67px;
  & strong {
    color: ${props => props.theme.fontColors.headingColor};
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-weight: ${props => props.theme.fontWeight.bold};
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px; 
    margin-top: ${props =>(props.mt === undefined)? "0px": props.mt};
    margin-bottom:${props =>(props.mb === undefined)? "20px": props.mb};
    margin-right: 0px;
  }
`;

export const BasicInfoDarkFont = styled(BasicInfo)`
color: ${props => props.theme.fontColors.headingColor};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
  margin-top: ${props =>(props.mt === undefined)? "0px": props.mt}
}
`

export const BasicMobileInfo = styled.div`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 3px;
  }
`;

export const BasicInfoMinMax = styled.div`
${fontCommonStyle}
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
margin-top: ${props => props.marginTop};
margin-bottom: ${props => props.marginBottom};
line-height: ${props => props.theme.lineHeight.primary};
color: ${props => props.theme.fontColors.headingColor};   
content: none;
`;

export const Title = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  margin-top: ${props => props.marginTop};
  line-height: ${props => props.theme.lineHeight.popUpHeading};
  color: ${props => props.theme.fontColors.headingColor};
  padding-top: 6px;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media only screen and (min-width: 320px) and (max-width: 767px){
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.primary};
    padding-top: 0px;
  }
`;

export const SubTitle = styled(Title)`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
`;

export const CheckboxContent = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
line-height: 1.5;
color: ${props => props.theme.fontColors.textColor};
margin-top: 2px;
margin-bottom: ${props => props.marginBottom};
margin-left: ${props =>(props.marginLeft === undefined)? "2px": props.marginLeft};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: 1.57;
  letter-spacing: normal; 
  margin-left: ${props => props.mLB ? props.mLB : '10px'};
}`;


export const ComponentDivider = styled(Divider)`
&&&
.ant-divider, 
  .ant-divider-horizontal{
     margin-top: ${props => props.marginTop ? props.marginTop : "30px" };
     margin-bottom: ${props => props.marginBottom ? props.marginBottom : "30px" };
     background: #d4d4d4;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
&&&
.ant-divider, 
  .ant-divider-horizontal{
    margin-top: ${props => props.mT ? props.mT : "30px" };
     margin-bottom: ${props => props.mB ? props.mB : "30px" };
     background: #d4d4d4;
}
}

`;

export const WrapLabel = styled.div`
&&& {
  .ant-form-item-label{
    margin-bottom: 10px;
   }
   .ant-form-item{
     margin-bottom: 40px;
   }
   .ant-form-item-control {
    line-height: unset !important;
  }
   @media only screen and (min-width: 320px) and (max-width: 767px) {  
    &&& {
      .ant-form-item-label{
        padding: 0;
       }
   }
}
`;
export const LabelWrapper = styled.span`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
line-height: 1.25;
height: 20px;
color: #505050;
font-weight: normal;
.ant-form-item-label {
  height:20px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: 14px;
}
`;

export const InputWrapper = styled.div`
input, .ant-input{
  border: solid 1px #d4d4d4;
  border-radius: 0;
}
.ant-select-selection__rendered{
  display: flex;
  align-items: center;
}
`;

export const InputAddressWrapper = styled.div`
input,
.ant-select-selection--single {
height: 30px;
}
.ant-input{
  border: solid 1px #d4d4d4;
  border-radius: 0;
}
`;

export const GrantAgreementDropdown = styled(Select)`

  width: 200px;
  height:40px;

.ant-select-selection{
  border-radius : 0px;
  height:40px;
  border-color: #d9d9d9;
}

.ant-select-selection--multiple .ant-select-selection__rendered {
  height:40px;
  margin-bottom:-4px;
}
.ant-select-selection__rendered {
  margin-left: 20px;
}
.ant-select-selection__rendered > ul > li{
margin-top:7px;
}

.ant-select-search--inline {
  top: 0px;
  left: 0px;
}

.ant-select-arrow{
  top: -1px !important;
  padding: 13px 13px 16px 13px;
  background-color: #f5f5f5;
  margin: 1px 1px;
  right: 0;
  bottom: 0;
  border-left: 1px solid #d4d4d4;
  color: #606060;
}

.has-error .ant-select-selection {
  border-color: ${props => props.theme.colors.lightGrey};
}
.has-error .ant-calendar-picker-icon::after, .has-error .ant-time-picker-icon::after, .has-error .ant-picker-icon::after, .has-error .ant-select-arrow, .has-error .ant-cascader-picker-arrow {
  color: ${props => props.theme.colors.lightGrey};
}

.ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active{
  border: 1px solid ${props => props.theme.colors.lightGrey} !important;
  box-shadow:none !important;
}
.ant-select-selection.ant-select-selection--single:focus {
  border: 1px solid #505050 !important;
  outline-color: #505050 !important;
  outline-width: 1px !important;
}
`;

export const SelectOptionWrapper = styled.div`
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.fontColors.textColor};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
    &:hover {
      color: ${props => props.theme.colors.darkBlue};
    }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
`

export const SelectDropdown = styled(SelectOptionWrapper)`
  font-family: HelveticaNeue;
  font-size: 1rem;
  color: #505050;
`;

export const CheckboxWrapper = styled.div`
display: flex;
 .ant-checkbox-wrapper{
display: flex;
height: 18px;
}
.ant-checkbox{
  top: 4px;
  height: 18px;
} 
.ant-checkbox-checked::after {
  border: none;
}
margin-bottom: ${props =>(props.marginBottom === undefined)? "0px": props.marginBottom}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .ant-checkbox{
    top: 3px;
    height: 18px;
    width: 18px;
  } 
  margin-bottom: ${props =>(props.mb === undefined)? "0px": props.mb}
}


`;

export const CheckBoxMobileWrapper = styled.div`
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-bottom:0 px;
}
`;

export const CheckboxWrapperMain = styled(CheckboxWrapper)`
  display: flex;
  margin-bottom:30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-bottom:20px;
}
`

export const FormWrapper = styled.div`
margin-left: 32px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-left: 28px;
}
`;

export const InputMargin = styled.div`
.ant-form-item{
  margin-bottom: 0px;
}
`;
export const FormContainer = styled(Form)`
  &&& {
    .ant-form-item-control .ant-calendar-picker,
    .ant-input-number {
      width: 100%;
    }
    .ant-form-item-control{
        line-height: normal;
      }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    &&& {
    .ant-form-item{
      margin-bottom: 30px;
    }
  }
  }
`;

export const SelectDropdownStyles = styled.div`
.ant-select-dropdown {
  top: 43px !important;
  width: 100% !important;
  }
  .ant-select-selection__placeholder {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: 1.13;
    color: ${props => props.theme.fontColors.placeholder} !important;
  }
  .ant-select-dropdown {
    border: 1px solid ${props => props.theme.fontColors.placeholder};
    border-top: none;
    border-radius: 0;
    box-shadow: -7px 9px 15px 0 rgba(223, 223, 223, 0.5);
    li {
    background-color: #ffffff;
    padding: 5px 20px;
    }
    li:hover {
    color: #167f91;
    background-color: #e6f7ff;
    }
    }
    .ant-select-selection-selected-value div{
      font-family: HelveticaNeue;
      font-size: 1rem;
      color: #505050;
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        font-size: 14px;
      }
    }
    
    .ant-select-dropdown:after {
    bottom: 0;
    }

    .ant-select-selection__rendered {
      height: 100%;
    }
    .ant-select-selection__placeholder {
      padding-left: 9px;
    }
    .ant-select-selection:focus,.ant-select-selection:hover {
      border: 1px solid #d9d9d9!important;
      box-shadow: none!important;
    }
` 

export const PillButtonAdd = styled(PillButton)`
  ${styles}
  
  margin: 0 0 8px 0px;
  margin-bottom: ${props => props.marginBottom} !important;
  margin-right: ${props => props.marginRight} !important;
  color: #006778;
  background-color: #f5f5f5;
  font-family: HelveticaNeue-Medium;
  font-size: 14px;
  display: flex;
  white-space: pre-wrap;
  align-items: center;
  &:hover, &:focus {
    color: #006778 !important;
    border: 1px solid #d4d4d4 !important;
    background-color: #f5f5f5 !important;
  }
  &.ant-btn[disabled]:hover{
    opacity: ${props => (props.opacity ? props.opacity : "1")};
    background-color: #d4d4d4 !important;
    color: rgba(0, 0, 0, 0.25) !important;
  }
  
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 20px !important;
    width: ${props => props.width};
    height: 100%;
    border-radius: 24px !important;
  }
`;

export const TimeWrapper = styled.span`
${fontCommonStyle}
line-height: 1.5;
margin-top:  ${props => props.marginTop};
margin-bottom: ${props => props.marginBottom};
font-weight:  ${props => props.fontWeight};
margin-left: ${props => props.marginLeft};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: 14px;
}
`;

export const SelectErrorWrapper = styled.div`
input,
.ant-select-selection--single {
height: 40px;
}
.ant-input{
  border: solid 1px #d4d4d4;
  border-radius: 0;
}
width: 300px;
margin-bottom:5px;
`;

export const ErrorMesage = styled(ErrorMessage)` 
  margin-top: 10px;
  color: ${props=> props.morningStar? props.theme.fontColors.textColor: props.theme.fontColors.error};
  font-size: ${props => props.morningStar? props.theme.fontSize.secondary: props.theme.fontSize.primary};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const CollapseWrap = styled.div`
    margin-bottom: 20px;
    .ant-collapse {
        background: #ffffff;
        border-radius: 0px;
    }

    .ant-collapse-content {
        border-top: none;
    }
`;

export const ContentWrapper = styled.div`
    padding: 13px 0 20px 30px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      padding: 10px 20px 10px 20px;
    }
`;

export const SelectWrapper = styled.div`
input,
.ant-select-selection--single {
height: 40px;
width: ${props => (props)? props.inputWidth : ''}
}
.ant-select-selection{
border: solid 1px #d4d4d4;
border-radius: 0;
}
`;

export const HideArrow = styled.div`
&&& .ant-select-dropdown:after{
bottom: 0;
}
`;

export const CompleteIcon = styled.img`
margin-right:${props=> props.status?"":"10px"};
height:36px;
width:36px;
`;

export const CompleteMessage = styled.span`
background-color: "#69923a";
font-family: HelveticaNeue;
font-size: 16px;
color: ${props=> props.status?"#69923a":"#d4d4d4"};
margin-right:20px;
align-self: center;
`;

export const ContentMessage = styled.div`
display: flex;
justify-content: ${props => props.justify};
align-items: ${props => props.align};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  flex-direction: ${props => props.mbFlexDirection === undefined ? 'column' : props.mbFlexDirection};
  margin-bottom: ${props=> props.marginBottom}
  width: 100%;
}
`;

export const SaveAndContinue = styled.span`
background-color : "#d4d4d4";
color: "#ffffff";
`;

export const NoticeBorder = styled.div`
border-left: 6px solid ${props => props.theme.colors.info};
width: 100%;
margin-bottom: 30px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  width: 100%;
  border-left: none;
  border-top: 4px solid ${props => props.theme.colors.info};
}
`;

export const ViewEditRemove = styled.div`
display: flex;
align-items: center;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  display: block;
}
`;

export const ViewEditWrapper = styled.div`
margin-right: 20px;
`;

export const OptionWrapper = styled.div`
  font-family: HelveticaNeue;
  color: #606060;
  font-size: 14px;
  line-height: 2.15;
  padding: 2px 0;
  font-weight: normal;
`;

export const SelectOptionGraded = styled.div`
.ant-select-selection {
  .ant-select-arrow {
    i {
      display: block;
    }
  }
} 
.ant-select-arrow {
    color: #606060;
    width: 40px;
    height: 100%;
    top: -1px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #d4d4d4;
    background: #f5f5f5;
  }
`;

const InputWrapped = styled.div`
  input,
  .ant-select-selection--single {
    height: 40px !important;
  }

  .ant-select-arrow-icon {
    display: none;
  }

  input::placeholder {
    color: #d4d4d4;
  }

  .ant-select-selection {
    border-radius: 0;
    display: flex;
    align-items: center;
    border: 1px solid #d4d4d4;
  }

  .ant-input {
    border-radius: 0;
    color: #505050;
    font-size: 16px;
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
    }
  }

  .ant-calendar-picker-input {
    margin-top: 0 !important;
  }
`;


export const InputWrapperGraded = styled(InputWrapped)`
  input,
  .ant-select-selection--single {
    background-color: #f2f2f2 !important;
  }

  input {
    padding: 0 20px;
  }

  input::placeholder {
    color: #d4d4d4;
  }

  .ant-select-selection-selected-value {
    color: #505050;
    font-size: 16px;
    padding: 0 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
    }
    
  }

  .ant-select-selection__rendered {
    margin: 0;
  }
`;

export const Underlinelink = styled(UnderlineLink)`
  letter-spacing: normal;
  white-space: nowrap;
  ${styles}
  font-family: HelveticaNeue;
  &:hover {
    text-decoration: underline;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: inline-block;
    font-size: 14px;    
  }
`;

export const RemoveWrapper = styled.div`
margin-left: 20px;
margin-bottom: 4px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-left: 0;
  margin-top: 10px;
}
`;

export const AccessKeyWrapper = styled.div`
${fontCommonStyle}
& a {
font-family: ${props => props.theme.fontFamily.helveticaNeue};
}
padding:20px 0 0 35px;
width: fit-content;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: 14px;
}
`;

export const ContentKeyWrapper = styled.div`
  padding:20px 0 0 35px;
  width: fit-content;
  margin-left:40px;
  font-size: 16px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold} !important;
  color:${props => props.theme.fontColors.headingColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 16px;
  }
`;

export const RemoveFundWrapper = styled.div`
  margin-bottom:30px;
`;

export const AccountLinkWrapper = styled(UnderlineLink)`
font-family: ${props => props.theme.fontFamily.helveticaNeue} !important;
margin-left: ${props => props.marginLeft ? props.marginLeft : ''};
font-size: ${props => props.theme.fontSize.primary} !important;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  margin-left: ${props => props.marginLeft ? '20px' : ''}
  font-size: ${props => props.theme.fontSize.secondary} !important;
}
`;

export const NoticeContent = styled.div`
  justify-content: space-between !important;
  align-items: center;
  font-size: ${props => props.theme.fontSize.primary};
  && div > a {
    color: ${props => props.theme.colors.primaryColor};
  }
  color: ${props => props.theme.fontColors.textColor};
  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
    font-size: ${props => props.theme.fontSize.secondary};
    justify-content: space-between !important;
    & > div:nth-child(1) {
      flex-basis: 75%;
      line-height: ${props => props.theme.lineHeight.secondary};
    }
    & > button {
      width: initial;
      align-self: flex-start;
    }
    width:100%;
  }
`;

export const DownIcon = styled(Icon)`
  font-size: 10px; 
  padding-top: 0.24rem;
`;

export const ButtomDisplay = styled.div` 
display: flex;
`;

export const Guildelines = styled(UnderlineLink)`
font-family: ${props => props.theme.fontFamily.helveticaNeue} !important;
font-size: ${props => props.theme.fontSize.primary} !important;
cursor: pointer;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary} !important;
}
`;


export const SelectComp = styled(Select)`

.ant-select-selection{
  border-radius : 0px;
}

.ant-select-arrow {
  color: #606060;
  width: 40px;
  height: 100%;
  top: 6px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #d4d4d4;
  background: #f5f5f5;
}
.ant-select-selection--single{
  height: 40px;
  border-color: #d9d9d9;
}

.ant-select-selection__rendered {
  margin-left: 20px;
}

.has-error .ant-select-selection {
  border-color: #d9d9d9;

}
.has-error .ant-calendar-picker-icon::after, .has-error .ant-time-picker-icon::after, .has-error .ant-picker-icon::after, .has-error .ant-select-arrow, .has-error .ant-cascader-picker-arrow {
  color: #d9d9d9;
}

.has-error .ant-form-explain {
  margin-top: 0px !important;
  line-height: 0;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  width: 100%;
}
@media only screen and (min-width: 728px) and (max-width: 1023px) {
}
@media only screen and (min-width: 1023px) and (max-width: 1439px) {
   width: 170px;
}
`;

export const PlusIcon = styled.div`
@media only screen and (min-width: 320px) and (max-width: 350px) {
  margin-top:${props => props.marginTop};
}
@media only screen and (min-width: 350px) and (max-width: 767px) {
  line-height: ${props => props.theme.fontSize.heading};
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  display: inline-block;
  vertical-align: middle;
}
`;

export const VanguardDonor = styled.div`
  ${fontCommonStyle}
  margin-left: 35px;
  ol{
    margin-bottom: 0;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const RouteTo = styled(LinkTo)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
`;

export const CapsuleButtonWrapper = styled.div`
  margin-bottom: ${props => props.marginBottom};
  margin-right: ${props => props.marginRight};
  margin-top: ${props => props.marginTop};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-right: ${props => props.mobMRight};
    margin-top: ${props => props.mobMTop};
  }
`;